export default __webpack_public_path__ + "static/media/7_piano_prodigy.cbe3a302.png";